import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, useHistory } from 'react-router-dom';
import {
  generateToken,
  tokenSentTimeAction,
  validateToken,
} from '../../store/auth/actions';
import {
  Wrapper,
  Content,
  Title,
  Description,
  EmailMask,
  Subtitle,
  ButtonContainer,
  Button,
  InfoContainer,
  RecoverText,
  TextClick,
  IconAlert,
} from './styles';
import moment from 'moment';
import Toast from '../../components/Toast';
import { toast } from 'react-toastify';
import Loading from '../../components/Loading';
import InputToken from '../../components/InputToken';
import { navigationUrl } from '../../store/analytic/actions';

const VerifyToken: React.FC = () => {
  const dispatch = useDispatch();
  const configs = useSelector((state: ApplicationState) => state.config);
  const history = useHistory();
  const [token, setToken] = useState<string>('');
  const [errorToken, setErrorToken] = useState<boolean>(false);
  const [loading, setLoading] = useState(false);
  const {
    selectedContact,
    isAuthenticated,
    acceptedTerms,
    expired,
  } = useSelector((state: ApplicationState) => {
    return {
      selectedContact: state.contacts.selected,
      isAuthenticated: state.auth.signed,
      acceptedTerms: state.auth.user?.acceptedTerms,
      expired: state.auth.status,
    };
  });

  useEffect(() => {
    dispatch(generateToken.failure('')); // apenas para mudar o status;
    dispatch(
      navigationUrl.request({
        action: '/validarToken',
      })
    );
  }, [dispatch]);

  useEffect(() => {
    setErrorToken(expired === 'Token inválido');
  }, [expired]);

  useEffect(() => {
    errorToken && setLoading(false);
  }, [errorToken]);

  const handlerDigit = (value: string) => {
    const digits = value.replace(/\s/g, '');
    setToken(digits);
  };

  const handlerConfirm = () => {
    if (token.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1').length !== 6) {
      return toast.error(
        <Toast
          title={'Credencial inválida!'}
          description={'Coloque um token válido!'}
        />
      );
    }
    setErrorToken(false);
    setLoading(true);
    dispatch(generateToken.failure(''));
    dispatch(validateToken.request(token));
  };
  const handleBack = () => history.goBack();
  if (!selectedContact) return <Redirect to='/acordos-debitos' />;
  if (isAuthenticated && acceptedTerms)
    return <Redirect to='/acordos-debitos' />;
  if (isAuthenticated && !acceptedTerms) return <Redirect to='/termos' />;

  const handleSendAgain = () => {
    setToken('');
    setErrorToken(false);
    setLoading(false);
    dispatch(generateToken.failure(''));
    dispatch(generateToken.request());
    dispatch(tokenSentTimeAction(moment().toDate()));

    toast.error(
      <Toast title={'Aviso'} description={'Token enviado novamente'} />
    );
  };

  return (
    <Wrapper>
      <Content>
        <Title>Verificação em duas etapas</Title>

        <Description>
          Uma mensagem de texto com um código de verificação de 6 dígitos acabou
          de ser enviada para
          <EmailMask>
            {(selectedContact as GQL.IEmail).email ||
              (selectedContact as GQL.ITelephone).telephone}
          </EmailMask>
        </Description>

        <Subtitle>Digite abaixo o código de verificação:</Subtitle>
        <InputToken
          value={token}
          error={errorToken}
          change={(e: React.ChangeEvent<HTMLInputElement>) =>
            handlerDigit(e.target.value)
          }
          onClickButtonExpired={handleSendAgain}
          countDown={true}
          onkeypress={(e: { key: string }) => {
            if (e.key === 'Enter') handlerConfirm();
          }}
        />

        <ButtonContainer>
          <Button color='secondary' onClick={handleBack}>
            Voltar
          </Button>
          <Button color='primary' onClick={handlerConfirm} disabled={loading}>
            {loading ? <Loading /> : 'Avançar'}
          </Button>
        </ButtonContainer>

        <InfoContainer>
          <IconAlert />
          <RecoverText>
            Se você não recebeu o código de verificação,{' '}
            <TextClick onClick={handleSendAgain}>clique aqui</TextClick> para
            reenviar. Ou entre em contato com a assessoria pelo telefone{' '}
            <a href={`tel:${configs.assessoriaTelephone}`}>
              {configs.assessoriaTelephone}
            </a>{' '}
            ou através de um dos meios listados abaixo.
          </RecoverText>
        </InfoContainer>
      </Content>
    </Wrapper>
  );
};

export default VerifyToken;
